import * as types from './types';

const initialState = {
  GetProgramActivities: {},
  ProgramActivities: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case types.PROGRAM_ACTIVITY_GET_SUCCESS: {
      return {
        ...state,
        GetProgramActivities: action.payload
      };
    }
    case types.PROGRAM_ACTIVITY_GET_FAILURE:
      return { ...state, error: action.payload };
    case types.PROGRAM_ACTIVITY_SUCCESS: {
      return {
        ...state,
        ProgramActivities: action.payload
      };
    }
    case types.PROGRAM_ACTIVITY_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
